import { type IdeaStatus, type PublicIdea, PublicIdeaSchema } from '@cult/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../../../lib/api-client';
import { ideaKey } from './use-idea';
import { ideaHistoryKey } from './use-idea-history';

export type TransitionInput = {
  ideaId: string;
  to: IdeaStatus;
  note?: string;
};

const useTransitionIdea = () => {
  const queryClient = useQueryClient();
  return useMutation<PublicIdea, Error, TransitionInput>({
    mutationFn: async (input) => {
      const raw = await apiFetch<unknown>(`/ideas/${input.ideaId}/transition`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ to: input.to, note: input.note }),
      });
      return PublicIdeaSchema.parse(raw);
    },
    onSuccess: (idea) => {
      // useIdea is keyed by idea.number (the URL-facing id), not idea.id (UUID)
      queryClient.setQueryData(ideaKey(String(idea.number)), idea);
      queryClient.invalidateQueries({ queryKey: ['ideas'], exact: false });
      // One status-history cache, shared by the idea page and the admin drawer.
      queryClient.invalidateQueries({ queryKey: ideaHistoryKey(idea.id) });
    },
  });
};
export default useTransitionIdea;
